import { SelfUpdateAdminRequest } from '../../../types/userProfile/SelfUpdateAdminRequest';
import { useGetSelfAdminUserQuery } from '../../../API/administration/AdminUsersAPI';
import { useMemo } from 'react';
import { eWeekdays } from '../../../types/userProfile/IUserProfile';

export const useInitialSelfUpdateFormValues = (): SelfUpdateAdminRequest => {
  const { data } = useGetSelfAdminUserQuery();
  return useMemo(() => {
    return {
      pronouns: data?.pronouns ?? '',
      timeZone: data?.timeZone ?? '',
      phoneNumber: data?.phoneNumber ?? '',
      phoneExtension: data?.phoneExtension ?? null,
      externalEmail: data?.externalEmail ?? '',
      languages: data?.languages ?? [],
      notes: data?.notes ?? '',
      workSchedule: {
        [eWeekdays.Monday]: {
          startTime: data?.workSchedule?.[eWeekdays.Monday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Monday]?.endTime ?? '',
        },
        [eWeekdays.Tuesday]: {
          startTime: data?.workSchedule?.[eWeekdays.Tuesday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Tuesday]?.endTime ?? '',
        },
        [eWeekdays.Wednesday]: {
          startTime: data?.workSchedule?.[eWeekdays.Wednesday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Wednesday]?.endTime ?? '',
        },
        [eWeekdays.Thursday]: {
          startTime: data?.workSchedule?.[eWeekdays.Thursday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Thursday]?.endTime ?? '',
        },
        [eWeekdays.Friday]: {
          startTime: data?.workSchedule?.[eWeekdays.Friday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Friday]?.endTime ?? '',
        },
        [eWeekdays.Saturday]: {
          startTime: data?.workSchedule?.[eWeekdays.Saturday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Saturday]?.endTime ?? '',
        },
        [eWeekdays.Sunday]: {
          startTime: data?.workSchedule?.[eWeekdays.Sunday]?.startTime ?? '',
          endTime: data?.workSchedule?.[eWeekdays.Sunday]?.endTime ?? '',
        },
      },
    };
  }, [data]);
};
